const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const blank = (v) => !v || !String(v).trim();

export function validateRegistration(f, role) {
  const e = {};
  const isArtist = role === "artist";
  const isSupplier = role === "supplier";
  const isPA = role === "public_entity";
  const isBiz = role === "business";
  const isCitizen = role === "citizen";
  const needsVat = (isArtist || isSupplier) ? f.hasVat : isBiz;

  if (blank(f.email)) e.email = "Email obbligatoria";
  else if (!EMAIL_RE.test(f.email)) e.email = "Formato email non valido";
  if (!f.socialPending && blank(f.password)) e.password = "Password obbligatoria";
  else if (!f.socialPending && f.password.length < 6) e.password = "Minimo 6 caratteri";

  if (isArtist || isCitizen) {
    if (blank(f.firstName)) e.firstName = "Nome obbligatorio";
    if (blank(f.lastName)) e.lastName = "Cognome obbligatorio";
  }
  if ((isArtist || isSupplier || isBiz) && blank(f.companyName)) e.companyName = "Campo obbligatorio";
  if (isPA) {
    if (blank(f.entityName)) e.entityName = "Nome Ente obbligatorio";
    if (blank(f.referentName)) e.referentName = "Nome referente obbligatorio";
    if (blank(f.ipaCode)) e.ipaCode = "Codice IPA obbligatorio";
    else if (!/^[A-Z0-9]{6}$/.test(f.ipaCode)) e.ipaCode = "Il codice IPA è di 6 caratteri alfanumerici";
    if (blank(f.pec)) e.pec = "PEC obbligatoria";
    if (f.splitPayment !== true && f.splitPayment !== false) e.splitPayment = "Indica se l'Ente è soggetto a Split Payment";
  }

  if (blank(f.taxCode)) e.taxCode = "Codice Fiscale obbligatorio";
  else if (isArtist && !/^[A-Z0-9]{16}$/.test(f.taxCode)) e.taxCode = "Inserisci il codice fiscale personale dell'artista (16 caratteri)";
  else if (!/^[A-Z0-9]{16}$/.test(f.taxCode) && !/^\d{11}$/.test(f.taxCode)) e.taxCode = "Inserisci 16 caratteri (persona) o 11 cifre (ente/società)";
  if (blank(f.city)) e.city = "Città obbligatoria";
  if (isArtist && (blank(f.residenceAddress) || f.residenceAddress.trim().length < 5)) e.residenceAddress = "Indirizzo di residenza obbligatorio";

  if (needsVat) {
    if (blank(f.vatNumber)) e.vatNumber = "Partita IVA obbligatoria";
    else if (!/^\d{11}$/.test(f.vatNumber)) e.vatNumber = "La Partita IVA è di 11 cifre";
  }
  if (!blank(f.atecoCode) && !/^\d{2}(\.\d{1,2}){0,2}$/.test(f.atecoCode)) e.atecoCode = "Formato ATECO non valido (es. 90.01.09)";
  if (!blank(f.sdiCode) && !/^[A-Z0-9]{7}$/.test(f.sdiCode)) e.sdiCode = "Il codice SDI è di 7 caratteri";
  if (!blank(f.pec) && !EMAIL_RE.test(f.pec)) e.pec = "Formato PEC non valido";

  const ownArea = isArtist ? "artist" : isSupplier ? "supplier" : null;
  if (ownArea && !f.vatRegime) e.vatRegime = "Seleziona la tua aliquota o regime IVA";
  if (ownArea && !Object.values((f.taxonomy || {})[ownArea] || {}).some((s) => s.length)) e.taxonomy = "Seleziona almeno una sottocategoria della tua area";
  if ((isArtist || isSupplier) && Number(f.baseFeeNet) < 0) e.baseFeeNet = "Il compenso non può essere negativo";
  if ((isArtist || isSupplier) && Number(f.coverageMaxKm) < 0) e.coverageMaxKm = "Valore non valido";
  if ((isArtist || isSupplier) && (f.travelRatePerKm === "" || Number(f.travelRatePerKm) < 0)) e.travelRatePerKm = "Indica la tariffa al km (anche 0)";
  return e;
}

export function serverErrorsToFields(err) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;
  if (status === 409) return { email: "Email già registrata" };
  if (status === 422 && Array.isArray(detail)) {
    const out = {};
    detail.forEach((d) => {
      const key = d.loc?.[d.loc.length - 1];
      if (typeof key === "string") out[key] = key === "password" ? "Minimo 6 caratteri" : key === "email" ? "Formato email non valido" : (!d.type && d.msg ? d.msg : "Valore non valido");
    });
    return out;
  }
  return null;
}
